import {field} from '../field'
import {mergeConfig} from '../../configStore'
import {DateField, FieldReturn} from '../../types'

export const date = (props?: DateField, mergeProps?: Partial<DateField>): FieldReturn =>
  field('date', mergeConfig('date', props, mergeProps))
